const UserDoesnotExistPage = () => {
  const pageStyle = {
    height: '90vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    fontFamily: 'sans-serif'
  };
  const imgStyle = {
    width: '50%'
  };

  return (
    <div style={pageStyle}>
      <h1
        style={{
          margin: '0',
          padding: '0'
        }}
      >
        You do not have access to incorta care.
      </h1>
      <p>Please contact your administrator to grant you access</p>
      <img src="/images/error.jpg" style={imgStyle} />
    </div>
  );
};

export default UserDoesnotExistPage;
